<script setup lang="ts">
import { defineEmits, defineProps, ref } from 'vue';
const props = defineProps<{
    modelValue: boolean;
    customClass?: string;
    hasError?: boolean,
    errorMessage?: string
}>();

const checkstatus = ref( props.modelValue);

const emit = defineEmits(['update:modelValue']);

const handleChange = (event: Event) => {
    const target = event.target as HTMLInputElement; 
    checkstatus.value = target.checked;
    emit('update:modelValue', target.checked);
}

</script>

<template>
    <div class="checkbox-container">
        <label :class="['custom-checkbox', customClass]">
            <input type="checkbox" :checked="checkstatus" @change="handleChange" />
            <span :class="['custom-checkbox__box', { 'has-error': hasError }]"></span>
        </label>
        <slot name="label"></slot>
    </div>

    <!-- Error message -->
    <span v-if="hasError" class="error-message">{{ errorMessage }}</span>

</template>


<style scoped lang="scss">
@import 'CheckboxComponent.scss';
</style>